// project-imports
import { getRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - PRODUCTS ||============================== //

export async function handleProducts(action: APIAction) {
  switch (action.method) {
    case 'read':
      return getRequest(`/products?type=${action.data.type}`);
    default:
      console.info('[ApiManager > handleApiAction > handleProducts] - Unknown method');
      break;
  }
}
